import './MorningstarRegistration.scss';

import React, { useState, Fragment } from 'react';
import Store from 'state/Store';
import ActionButton from 'components/shared/Buttons/ActionButton';
import Content from 'services/Content';
import ConsentModal from 'components/shared/Modal/ConsentModal';
import {
  requestMorningstarConsent,
  getMorningstarAssociationUrl,
  getMorningstarAssociation
} from 'services/Rest';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { ReactComponent as MorningStarLogo } from 'assets/logo/logo-morningstar.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import { isError } from 'support/RequestSupport';
import { COMPLETE, LEGACY, NONE } from 'services/ServiceBenefits';
import {
  RECEIVED_MORNINGSTAR_CONSENT,
  ERROR_MORNINGSTAR_CONSENT
} from 'state/morningstar/MorningstarActions';
import ThirdPartyWebsiteModal from 'components/shared/Modal/ThirdPartyWebsiteModal';
import {
  showThirdPartyModal,
  targetURL
} from 'state/thirdParty/ThirdPartyModalActions';

const ActionButtonWithPermissions = WithUserPermissions(ActionButton);

const MorningstarRegistration = () => {
  const [showDisclosure, setShowDisclosure] = useState(false);

  const morningstarAssociationError = isError('morningstarAssociation');

  const handleAgree = () => {
    setShowDisclosure(false);

    requestMorningstarConsent().then((response) => {
      if (
        response.type === RECEIVED_MORNINGSTAR_CONSENT &&
        response.type !== ERROR_MORNINGSTAR_CONSENT
      ) {
        getMorningstarAssociationUrl().then((response) => {
          if (response) {
            const {
              payload: { memberUrl }
            } = response;
            if (memberUrl) {
              window && window.open(memberUrl, '_blank');
            }
          }
          return false;
        });
      }
    });
  };

  const handleOnClick = () => {
    getMorningstarAssociation().then((response) => {
      const {
        payload: { status, memberUrl }
      } = response;
      if (status === COMPLETE || status === LEGACY) {
        Store.dispatch(targetURL(memberUrl));
        Store.dispatch(showThirdPartyModal(true));
      }
      if (status === NONE) {
        setShowDisclosure(true);
      }
    });
  };

  return (
    <Fragment>
      <ThirdPartyWebsiteModal />
      {showDisclosure && (
        <ConsentModal
          close={() => setShowDisclosure(false)}
          containerClassName="morningstar-subscription-disclosure"
          hideAnchor={true}
          hideClose={false}
          isOpen={showDisclosure}
          label="morningstar-subscription-disclosure"
          title="Morningstar.com Premium Subscription"
          disableClickOff>
          <p
            className="morningstar-disclosure-copy"
            dangerouslySetInnerHTML={{
              __html: Content.morningstarPremiumContent
            }}
          />
          <div className="access-morningstar-btn">
            <ActionButton
              id="access-morningstar"
              type="primary"
              onClick={handleAgree}>
              Access Morningstar.com
            </ActionButton>
          </div>
        </ConsentModal>
      )}
      <div className="household-client-link morningstar-link">
        <MorningStarLogo className="household-morningstar-logo" />
        {!morningstarAssociationError && (
          <ActionButtonWithPermissions
            onClick={handleOnClick}
            id="morningstar-membership-btn-id"
            shouldDisable>
            <p className="premium-membership">Premium Membership</p>
            <ChevronRight className="chevron" />
          </ActionButtonWithPermissions>
        )}
      </div>
    </Fragment>
  );
};

export { MorningstarRegistration };
